<template>
    <div class="info-help">
        <div class="infobody-help">
            <div class="white-header">
                <div class="tenforty-wrap">
                    <router-link :to="$homeLink" class="c-back__box">
                        <span class="c-back__icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="14px">
                                <path
                                    d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z">
                                </path>
                            </svg>
                        </span>
                        <div>Return to info.my.vermont.gov</div>
                    </router-link>
                    <h1>Welcome to Electronic Death Registration System (EDRS) Support</h1>
                    <div class="sub-headings">
                        <p><b>How can we help you?</b></p>
                        <div class="image-row">
                            <Program_Logo class="help-icon" />
                        </div>
                        <img src="../../assets/VDH_logo_green_horiz.png" />
                        <p class="heading-instruction">
                            Please check the common problems and self-directed solutions available below before
                            contacting the program.
                        </p>
                    </div>
                </div>
            </div>
            <div class="tenforty-wrap">
                <p>This page contains guidance to assist you in accessing the Vermont Department of Health (VDH) Vital
                    Records Electronic Death Registration System (EDRS).</p>
                <p>Only authorized users may access this application. To request access, please contact the program
                    directly at the contact information provided at the bottom of this page.</p>
                <HelpMfaBlock :envLinks="envLinks" appsRequiring="a VDH application"
                    mfaSupportText="For support, please see contact information below.">
                </HelpMfaBlock>
                <HelpGeneral :envLinks="envLinks"></HelpGeneral>
                <h2 class="faq-header">Browser Compatibility</h2>
                <p class="faq-text">If you are having any issues accessing the application listed below, please make
                    sure the browser that you are using is compatible for use with the application you are trying to
                    access.</p>
                <table class="vdh_table">
                    <thead>
                        <tr>
                            <th>Vital Records Program</th>
                            <th>Compatible Browser</th>
                        </tr>
                    </thead>
                    <tbody class="section section-step">
                        <tr>
                            <td>Electronic Death Registration System</td>
                            <td class="brower-data">Edge and Firefox</td>
                        </tr>
                    </tbody>
                </table>
                <div class="noteAlt">
                    <i><font-awesome-icon icon="info-circle" /></i>
                    <div class="noteText">
                        <h2 class="faq-header">For Additional Information and Assistance</h2>
                        <p>
                            For additional information, or to contact VDH Vital Records, please click on the program
                            name or email contact information provided below:
                        </p>
                        <p></p>
                        <table class="">
                            <thead>
                                <tr>
                                    <th>Program</th>
                                    <th>Email</th>
                                </tr>
                            </thead>
                            <tbody class="section section-step">
                                <tr>

                                    <td><a href="https://www.healthvermont.gov/stats/vital-records/electronic-death-registration-system">Electronic Death
                                            Registration System (EDRS)</a></td>
                                    <td class="brower-data">
                                        <a class="email-link"
                                            href="mailto:edrs@vermont.gov?subject=Assistance with myVT - EDRS">edrs@vermont.gov</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Program_Logo from '../../assets/AHS_VDH_EDRS.vue'
import HelpMfaBlock from './HelpMFABlock.vue'
import HelpGeneral from './HelpGeneral.vue'
export default {
    name: 'help-vdh-patient-profile',
    props: ['envLinks'],
    components: {
        Program_Logo,
        HelpGeneral,
        HelpMfaBlock
    },
    mounted() {
        document.title = "myVT Help - VDH EDRS";
    },
}
</script>

<style scoped>
@import './help.css';

.help-icon {
    width: 100px;
}

ul {
    padding-left: 30px;
}

li {
    list-style-type: disc !important;
}

tbody td:nth-child(2) {
    padding-left: 16px;
}

thead th {
    padding-bottom: 10px;
}
</style>
